import { Component, OnInit } from '@angular/core';
import { VexPopoverRef } from '@vex/components/vex-popover/vex-popover-ref';
import { MatIconModule } from '@angular/material/icon';
import { RouterLink } from '@angular/router';
import { NgFor } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';

export interface MegaMenuFeature {
  icon: string;
  label: string;
  /** Internal Angular route (use for pages within this app) */
  route?: string;
  /** External URL (opens in new tab) — use for third-party apps */
  url?: string;
}


@Component({
  selector: 'vex-mega-menu',
  templateUrl: './mega-menu.component.html',
  standalone: true,
  imports: [MatButtonModule, NgFor, RouterLink, MatIconModule]
})
export class MegaMenuComponent implements OnInit {
  features: MegaMenuFeature[] = [
    {
      icon: 'mat:smart_toy',
      label: 'Lucy',
      url: 'https://lucy.kubico.co' // TODO: replace with real Lucy URL
    },
    {
      icon: 'mat:chat',
      label: 'CrediBot',
      url: 'https://credibot.kubico.co' // TODO: replace with real CrediBot URL
    },
    {
      icon: 'mat:record_voice_over',
      label: 'Auditor IA',
      route: '/auditor/lista'
    }
  ];

  constructor(private popoverRef: VexPopoverRef<MegaMenuComponent>) {}

  ngOnInit() {}

  close() {
    this.popoverRef.close();
  }
}
